module.exports = __webpack_public_path__ + "img/ico-pages.a6c9c64c.svg";